// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__7j21y","buttons":"PendingPaymentAlert_buttons__3ovEo"};